export let AngleUnit = /*#__PURE__*/function (AngleUnit) {
  AngleUnit["NONE"] = "none";
  AngleUnit["DEG"] = "deg";
  AngleUnit["GRAD"] = "grad";
  AngleUnit["RAD"] = "rad";
  AngleUnit["TURN"] = "turn";
  return AngleUnit;
}({});
export let ColorFormat = /*#__PURE__*/function (ColorFormat) {
  ColorFormat["A98"] = "a98";
  ColorFormat["RGB"] = "rgb";
  ColorFormat["RGBA"] = "rgba";
  ColorFormat["HSL"] = "hsl";
  ColorFormat["HSLA"] = "hsla";
  ColorFormat["HWB"] = "hwb";
  ColorFormat["LAB"] = "lab";
  ColorFormat["LCH"] = "lch";
  ColorFormat["OKLAB"] = "oklab";
  ColorFormat["OKLCH"] = "oklch";
  ColorFormat["DEVICE_CMYK"] = "device-cmyk";
  return ColorFormat;
}({});